/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Full_NameInputs */

const vi_user_full_name = /** @type {(inputs: User_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Họ tên`)
};

/**

* @param {User_Full_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_full_name = /** @type {((inputs?: User_Full_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Full_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_full_name(inputs)
});